import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutReportScheduleHistory extends Layout {
    sourceReportSchedHist: DataSource;
    tableHistory: Table;
}
